import React from 'react';
import PropTypes from 'prop-types';
import ToggleSwitch from 'components/consumer/ToggleSwitch';

const OrderIssueToggleSwitch = ({
  itemId,
  isChecked = false,
  boughtAsStocked = '0',
  stockDiscount = 0,
  isClearance = false,
  toggleOrderItem,
  yearsSinceOrderDelivered = 0,
}) => {
  if (boughtAsStocked === '1' && stockDiscount > 0 && isClearance) {
    return (
      <div className="text-xs pt-4">
        *Clearance items are not eligible <br /> for warranty service.
      </div>
    );
  }
  if (yearsSinceOrderDelivered < 10) {
    return (
      <ToggleSwitch
        key={`toggle-id-${itemId}`}
        onClick={() => {
          toggleOrderItem(itemId);
        }}
        isChecked={isChecked}
        size="sm"
        className="mt-4"
      >
        I have an issue with this
      </ToggleSwitch>
    );
  }
  return null;
};
OrderIssueToggleSwitch.propTypes = {
  itemId: PropTypes.number,
  isChecked: PropTypes.string,
  boughtAsStocked: PropTypes.string,
  stockDiscount: PropTypes.string,
  isClearance: PropTypes.number,
  toggleOrderItem: PropTypes.func,
  yearsSinceOrderDelivered: PropTypes.number,
};
export default React.memo(OrderIssueToggleSwitch);
